import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth";
import { Button, Field } from "../components/ui";
import { ForgotPassword } from "../components/ForgotPassword";
import { Icon } from "../components/icons";

export default function Login() {
  const { user, login, loginWithGoogle, authError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e?.preventDefault();
    if (!email.trim() || !password) return setError("Preencha o email e a palavra-passe.");
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="app-root" style={{ minHeight: "100vh", position: "relative", overflow: "hidden" }}>
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: 420,
          opacity: 0.6,
          background: "radial-gradient(120% 90% at 100% 0%, var(--brand-secondary) 0%, transparent 60%)",
          pointerEvents: "none",
        }}
      />
      <form
        onSubmit={submit}
        className="ulc-fade"
        style={{
          position: "relative",
          maxWidth: 520,
          margin: "0 auto",
          minHeight: "100vh",
          padding: "clamp(48px, 10vh, 120px) 24px 32px",
          display: "flex",
          flexDirection: "column",
          gap: 48,
          justifyContent: "center",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div className="t-kicker">COMUNIDADE PRIVADA</div>
          <h1
            data-testid="login-title"
            style={{ fontFamily: "var(--f-light)", fontWeight: 300, fontSize: 52, lineHeight: "54px", letterSpacing: 2, margin: 0 }}
          >
            URBAN<br />LISBON<br />CHOIR
          </h1>
          <div style={{ width: 48, height: 3, borderRadius: 999, background: "var(--brand-primary)", marginTop: 8 }} />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Field
            label="EMAIL"
            data-testid="login-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="nome@exemplo.pt"
            autoCapitalize="none"
            type="email"
            autoComplete="email"
          />
          <Field
            label="PALAVRA-PASSE"
            data-testid="login-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            type="password"
            autoComplete="current-password"
          />
          {error || authError ? (
            <div
              data-testid="login-error"
              style={{ background: "var(--error)", color: "var(--on-error)", padding: 12, borderRadius: "var(--r-md)", fontSize: 13 }}
            >
              {error || authError}
            </div>
          ) : null}
          <Button type="submit" loading={busy} data-testid="login-submit-button" style={{ marginTop: 8 }}>
            INICIAR SESSÃO
          </Button>

          <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "4px 0" }}>
            <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
            <span className="t-kicker" style={{ letterSpacing: 2 }}>OU</span>
            <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
          </div>

          <button
            type="button"
            data-testid="google-signin-button"
            onClick={loginWithGoogle}
            className="btn ghost"
            style={{ borderRadius: "var(--r-pill)", border: "1px solid var(--border-strong)", background: "var(--surface-2)" }}
          >
            <Icon name="person" size={18} /> Continuar com Google
          </button>

          <button
            type="button"
            data-testid="forgot-password-link"
            onClick={() => setForgot(true)}
            style={{ background: "none", border: "none", color: "var(--on-surface-3)", textDecoration: "underline", fontSize: 14, cursor: "pointer", padding: 12, alignSelf: "center" }}
          >
            Esqueceu-se da palavra-passe?
          </button>
        </div>
      </form>

      {forgot ? <ForgotPassword initialEmail={email} onClose={() => setForgot(false)} /> : null}
    </div>
  );
}
